import React, { createContext, useContext, FC, PropsWithChildren } from 'react';
import { Scalars, CrewMember, ScheduleHourType } from '@bechtel/types';

const TimesheetContextPrivate = createContext<TimesheetContextProps>({
  forDate: new Date(),
  crewEmployees: [],
  hourTypes: [],
  duration: 0,
  isEditable: false,
  roundingIncrement: 0.0,
});

const { Provider } = TimesheetContextPrivate;

export const useTimesheet = () => {
  return useContext(TimesheetContextPrivate);
};

interface TimesheetContextProps {
  forDate: Scalars['Date'];
  crewEmployees: CrewMember[];
  hourTypes: ScheduleHourType[];
  duration: Scalars['Float'];
  isEditable: Scalars['Boolean'];
  roundingIncrement: Scalars['Float'];
}

export const TimesheetContext: FC<PropsWithChildren<TimesheetContextProps>> = ({ children, ...props }) => {
  return <Provider value={props}>{children}</Provider>;
};
